import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'
import moment from 'moment'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dateNowFormatted: moment().format('DD/MM/YYYY HH:mm:ss'),
      dateNow: moment().format(),
      observation: '',
      dialog: false,
      isLoading: false,
      menuTimePicker: false,
      timepicker: null,
      menuEndDate: false,
      endDate: null,
      endDateFormated: null,
      closingDay: null,
      paidValue: 0
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedInvoice'
    ]),
    isDisabled () {
      return this.observation === '' || this.endDate === null || this.paidValue === 0 || this.timepicker === null
    }
  },
  watch: {
    endDateFormated (val) {
      if (!val) {
        this.endDate = null
      }
    }
  },
  mounted () {
    this.dialog = true

    this.closingDay = this.getterSelectedInvoice.closingDay === null ? 'Nenhum' : moment(this.getterSelectedInvoice.closingDay).format('DD/MM/YYYY HH:mm:ss')
  },
  beforeDestroy () {
    this.SET_SELECTED_INVOICE()
  },
  methods: {
    ...mapActions([
      'actionEditInvoice'
    ]),
    ...mapMutations([
      'SET_SELECTED_INVOICE'
    ]),
    getClosingDay (param, type = 'date') {
      const formatType = type === 'date' ? 'YYYY-MM-DD' : 'HH:mm:ss'
      let result = moment().format(formatType)

      if (param) {
        const [date, hour] = param.split('T')

        result = type === 'date' ? date : hour
      }

      return result
    },
    formatDateOfDatePicker (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    changeStatusExtract () {
      const paymentDate = `${moment(this.endDate).format('YYYY-MM-DD')}T${this.timepicker}:59`

      const params = {
        ...this.getterSelectedInvoice,
        paymentDate,
        paidValue: parseFloat(this.paidValue.replace('.', '').replace(',', '.')),
        settled: true,
        observation: this.observation
      }

      this.isLoading = true

      this.actionEditInvoice(params)
        .then(() => {
          this.closeModal()

          this.sendToast({
            text: 'Status do extrato alterado com sucesso!',
            type: 'success'
          })
        })
        .catch((error) => {
          this.setTypeOfMessageNotification(error)
        })
    },
    setTypeOfMessageNotification (response) {
      const updatedResponse = Object.prototype.hasOwnProperty.call(response, 'response') ? response.response : response
      const toast = (type = 'danger', text = 'Ocorreu um erro ao alterar o status do extrato, tente novamente mais tarde!') => this.sendToast({ text, type })

      if (updatedResponse && updatedResponse.data && updatedResponse.data.code) {
        switch (updatedResponse.data.code) {
          case 'INVOICE_NOT_UPDATE':
            toast('warning', 'O status do extrato foi atribuído como pago e não pode ser alterado')
            break
          default:
            toast()
        }
      } else {
        toast('danger', typeof response === 'string' ? response : toast.text)
      }

      this.isLoading = false
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
